import { telemetryIsPrivate } from './telemetryPrivacy';
/** GA4 helpers — safe no-ops for private documents or blocked analytics. */
export const gaEvent = (name, params = {}) => {
  if (telemetryIsPrivate()) return;
  try {
    if (typeof window.gtag === 'function') window.gtag('event', name, params);
  } catch { /* analytics must never break the app */ }
};

export const gaPageView = (path) => {
  gaEvent('page_view', {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
};
